export default __webpack_public_path__ + "static/ln-8ab5ae53c81f88687bed0e5a31106f9d.svg";